import React from 'react';

type ModalProps = {
  show: boolean;
  children: React.ReactNode;
  onClickOutside?: () => void;
};

function Modal({show, children, onClickOutside}: ModalProps) {
  const handleClickOutside = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onClickOutside && onClickOutside();
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full overflow-auto bg-dim-black ${
        show ? 'visible' : 'invisible'
      } transition-visibility duration-200`}
      onClick={handleClickOutside}
    >
      <div
        className={`bg-white rounded-l-gigantic h-full-6 my-3 float-right p-8 ${
          show ? 'w-2/5' : 'w-0'
        } transition-width duration-200 overflow-auto`}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default Modal;
